import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<
  IVisaPrepForm,
  | 'hasCriminalCharges'
  | 'hasTerrorismInvolvement'
  | 'hasTerrorismConnection'
  | 'hasTerrorismJustified'
  | 'hasWarCrimes'
  | 'hasBadActivities'
  | 'language'
>;

type Params = Fields;

export function getPageStatus({
  hasCriminalCharges,
  hasTerrorismInvolvement,
  hasTerrorismConnection,
  hasTerrorismJustified,
  hasWarCrimes,
  hasBadActivities,
  language,
}: Params): { complete: boolean } {
  let complete = false;
  if (
    hasCriminalCharges === undefined ||
    hasTerrorismInvolvement === undefined ||
    hasTerrorismConnection === undefined ||
    hasTerrorismJustified === undefined ||
    hasWarCrimes === undefined ||
    hasBadActivities === undefined ||
    language === undefined ||
    language === ''
  ) {
    complete = false;
  } else {
    complete = true;
  }

  return { complete };
}
